var _a;
import { __awaiter, __generator } from "tslib";
import { ART_STORE, ALBUMS } from '../constants';
import { HttpClient } from '@wix/http-client';
var httpClient = new HttpClient();
// copy of pro-gallery-artstore-statics wixAppsApi - TODO: delete
var wixProvidersArray = [ART_STORE.PROVIDERS.WIX, ART_STORE.PROVIDERS.LOCAL];
var getProviderId = function (connectedProviders) {
    return connectedProviders[Object.keys(connectedProviders)[0]].providerId;
};
var fetchConnectedProvider = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, err_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, httpClient.get(url)];
            case 1:
                response = _b.sent();
                if (response.status === 200) {
                    data = response.data;
                    if (data && data.providerId) {
                        return [2 /*return*/, (_a = {}, _a[data.providerId] = data, _a)];
                    }
                }
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                console.error(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); };
export default (_a = {},
    _a[ALBUMS.ALBUMS_APP_DEF_ID] = {
        getAdditionalParams: function (_a) {
            var albumId = _a.albumId, pricelistId = _a.pricelistId, freeArtStore = _a.freeArtStore, ignoreWatermark = _a.ignoreWatermark, downloadImageQuality = _a.downloadImageQuality;
            return {
                srcId: albumId,
                pricelistId: pricelistId,
                appDefId: ALBUMS.ALBUMS_APP_DEF_ID,
                ignoreWatermark: ignoreWatermark || false,
                isAlbumStore: true,
                freeArtStore: freeArtStore,
                canDownloadHighResolution: (downloadImageQuality === undefined && freeArtStore) ||
                    downloadImageQuality === ALBUMS.MAX_RESOLUTION.HIGH_RESOLUTION,
            };
        },
        getConnectedProviders: function (instanceId, _baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "https://www.wix.com/_api/albums-node-server/getAlbumConnectedProvidersByArtStoreInstanceId?instanceId=".concat(instanceId);
                        return [4 /*yield*/, fetchConnectedProvider(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getInvalidItemsForDownload: function (_a, mediaUrl, baseUrl) {
            var srcId = _a.srcId;
            return __awaiter(void 0, void 0, void 0, function () {
                var url, response, result;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            url = baseUrl +
                                "/albums-node-server/itemVerification?instanceId=".concat(srcId, "&uniqueIdToCheck=&").concat(mediaUrl);
                            return [4 /*yield*/, httpClient.get(url)];
                        case 1:
                            response = _b.sent();
                            result = response.data;
                            return [2 /*return*/, result.invalidItems];
                    }
                });
            });
        },
        getInstanceFromSettings: function (settings) { return settings.albumId || settings.srcId; },
        getInvalidItemsForDownloadUrl: function (_a) {
            var srcId = _a.srcId;
            return "/_api/albums-node-server/itemsVerification?instanceId=".concat(srcId);
        },
        getAdditionalQueryParams: function (providerParams) {
            var appDefId = providerParams.appDefId, srcId = providerParams.srcId;
            return "srcId=".concat(srcId, "&appDefId=").concat(appDefId);
        },
        getSectionsUrlWithParams: function (baseSectionsUrl, providerParams, connectedProviders) {
            var providerId = getProviderId(connectedProviders);
            if (!wixProvidersArray.includes(providerId)) {
                var appDefId = providerParams.appDefId, srcId = providerParams.srcId;
                var thank_you_page = baseSectionsUrl.thank_you_page, checkout_page = baseSectionsUrl.checkout_page;
                var queryParams = "?srcId=".concat(srcId, "&appDefId=").concat(appDefId);
                return {
                    thank_you_page: {
                        url: thank_you_page.url + queryParams,
                    },
                    checkout_page: {
                        url: checkout_page.url + queryParams,
                    },
                };
            }
            return baseSectionsUrl;
        },
        getSiteBusinessPackageData: function (locale, srcId, baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var url, response, retVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(baseUrl, "/albums-node-server/hasBusinessPackage?locale=").concat(locale, "&albumId=").concat(srcId);
                        return [4 /*yield*/, httpClient.get(url)];
                    case 1:
                        response = _a.sent();
                        retVal = response.data;
                        return [2 /*return*/, {
                                hasBusinessPackage: retVal.result,
                                metaSiteId: retVal.metaSiteIdForPackage,
                            }];
                }
            });
        }); },
        getSitebusinessPlanUrl: function (metaSiteId) {
            return "https://www.wix.com/store/plans?siteGuid=".concat(metaSiteId, "&businessTab=true&referralAdditionalInfo=photoAlbums");
        },
    },
    _a[ART_STORE.ARTSTORE_APP_DEFINITION_ID] = {
        getAdditionalParams: function () { return ({}); },
        getAdditionalQueryParams: function () { return ''; },
        getInstanceFromSettings: function () { },
        getConnectedProviders: function (instance, baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(baseUrl, "/pro-gallery-webapp/api/v1/store/providers?instance=").concat(instance, "&cache_buster=").concat(Math.random());
                        return [4 /*yield*/, fetchConnectedProvider(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getInvalidItemsForDownload: function (_a, mediaUrl, baseUrl) {
            var instance = _a.instance;
            return __awaiter(void 0, void 0, void 0, function () {
                var uniqueIdsToCheck, url, response, result;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            uniqueIdsToCheck = [mediaUrl];
                            url = baseUrl +
                                "/_api/pro-gallery-webapp/v1/items/verification?instance=".concat(instance);
                            return [4 /*yield*/, httpClient.post(url, JSON.stringify({ mediaUrls: uniqueIdsToCheck }), {
                                    headers: { 'Content-Type': 'application/json' },
                                })];
                        case 1:
                            response = _b.sent();
                            return [4 /*yield*/, response.data];
                        case 2:
                            result = _b.sent();
                            return [2 /*return*/, result.invalidItems];
                    }
                });
            });
        },
        getSectionsUrlWithParams: function (baseSectionsUrl, _params, _connectedProviders) {
            return baseSectionsUrl;
        },
        getSiteBusinessPackageData: function () { },
        getSitebusinessPlanUrl: function (_) { return ''; },
    },
    _a);
//# sourceMappingURL=wixAppsApi.js.map